import { render, staticRenderFns } from "./AppointmentTableActions.vue?vue&type=template&id=ab66413c&"
import script from "./AppointmentTableActions.vue?vue&type=script&lang=js&"
export * from "./AppointmentTableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports